module.exports = __webpack_public_path__ + "static/img/alarm.96347255.svg";